import $ from "jquery";
import "../semantic/semantic";
import "../semantic/semantic.css";

import "./logo.css";

import logoIcgc from "../assets/logo_txt.svg";
//import logoBlanc from "../assets/ICGC_white.svg";

export default function createLogo(parent) {

    const html = `<div id="logo" class="logocenter">
        <a href="http://icgc.cat">
            <img src="${logoIcgc}" class="logo">
        </a>
	</div>`;
	const template = document.createElement("template");
	template.innerHTML = html;

	$(parent).append(template.content.cloneNode(true));

}
